import get from 'lodash/get';
import { PAUSE_PREROLL_ENABLED } from '../constants/experiments/ads';

export const PREROLL = 'PREROLL';
export const PREROLL_LOAD = 'PREROLL_LOAD';
export const PLAY_PREROLL = 'PLAY_PREROLL';
export const SHOW_PREROLL_PLAYER = 'SHOW_PREROLL_PLAYER';
export const HIDE_PREROLL_PLAYER = 'HIDE_PREROLL_PLAYER';
export const PREROLL_PROGRESS = 'PREROLL_PROGRESS';
export const PREROLL_PAUSED = 'PREROLL_PAUSED';
export const PREROLL_RESUMED = 'PREROLL_RESUMED';
export const MINIMIZE_PREROLL_PLAYER = 'MINIMIZE_PREROLL_PLAYER';
export const EXPAND_PREROLL_PLAYER = 'EXPAND_PREROLL_PLAYER';
export const PREROLL_UPDATE_VOLUME = 'PREROLL_UPDATE_VOLUME';
export const SET_PREROLL_LEARN_MORE_URL = 'SET_PREROLL_LEARN_MORE_URL';
export const PREROLL_ERROR = 'PREROLL_ERROR';

export function showPrerollPlayer() {
  return { type: SHOW_PREROLL_PLAYER };
}

export function hidePrerollPlayer() {
  return { type: HIDE_PREROLL_PLAYER };
}

export function loadPreroll() {
  return { type: PREROLL_LOAD };
}

export function playPreroll() {
  return { type: PLAY_PREROLL };
}

export function handlePreroll(videoWidth, videoHeight) {
  return (dispatch, getState) => {
    const isPausePrerollEnabled = get(
      getState(),
      ['config', 'autoupdate', PAUSE_PREROLL_ENABLED],
      false,
    );
    return dispatch({
      type: PREROLL,
      videoWidth,
      videoHeight,
      isPausePrerollEnabled,
    });
  };
}

export function minimizePrerollPlayer() {
  return { type: MINIMIZE_PREROLL_PLAYER };
}

export function expandPrerollPlayer() {
  return { type: EXPAND_PREROLL_PLAYER };
}

export function handlePrerollProgress(timeData) {
  return { type: PREROLL_PROGRESS, timeData };
}

export function handlePrerollPause() {
  return { type: PREROLL_PAUSED };
}

export function handlePrerollResume() {
  return { type: PREROLL_RESUMED };
}

export function updateVolume(volume) {
  return { type: PREROLL_UPDATE_VOLUME, volume };
}

export function setLearnMoreUrl(url) {
  return { type: SET_PREROLL_LEARN_MORE_URL, url };
}

export function handlePrerollError() {
  return { type: PREROLL_ERROR };
}
